import * as yup from 'yup';

const withdrawalModalSchema = yup.object({
    amount: yup.string().required('Amount is required.'),
});

export type WithdrawalModalData = yup.InferType<typeof withdrawalModalSchema>;

export default withdrawalModalSchema;
